import React from "react";
import business from '../Images/business-premium.4b682d5c46a850fc85a127f7a22cc172.svg';
import policies from '../Images/policies-sold.0b1908c23f7151cb9669e0ce4e991966.svg';
import claim from '../Images/claims-assisted.d07ea9b83d2159eaed25122b262ae5df.svg';

export const OtherLink = () => {
    return (
        <div className="otherLinksSmc">
            <div className="StepsRow">
                <div className="StepsColm">
                    <img src={business} />
                    <div>
                        <small>Business Premium<br /><b>31.93 Billion +</b></small>
                    </div>
                </div>
                <div className="StepsColm">
                    <img src={policies} />
                    <div>
                        <small>Policies sold<br /><b>12.01 Million +</b></small>
                    </div>
                </div>
                <div className="StepsColm">
                    <img src={claim} />
                    <div>
                        <small>Claims assisted<br /><b>2.37 Million +</b></small>
                    </div>
                </div>
            </div>
        </div>
    );
};